import { ChangeContext, Options } from '@angular-slider/ngx-slider';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CellEditorStoreService } from '../../cell-editor-store.service';
import { ContentElement, ContentElementEnum, ContentStatusEnum, GridCell, RowCell } from '@urbannex/storethemes';
import { SectionBuilderStoreService } from '../../sections-editor/shared-section-builder/section-builder-store.service';
import { EditState } from '../../../model';
import { getEnumKeyByEnumValue } from '@urbannex/view-containers';

@Component({
  selector: 'kve-font-size-popover',
  templateUrl: './font-size-popover.component.html',
  styleUrls: ['./font-size-popover.component.scss']
})
export class FontSizePopoverComponent implements OnInit {

  content:ContentElement;
  title:string;
  status:ContentStatusEnum;
  service:string;

  currentValue;
  target:string;
  height;
  value:number;
  options: Options = {
    floor: 1,
    ceil: 40,
    step:1,
    showTicks: true
  };
  headerOptions:Options = {
    floor: 1,
    ceil: 6,
    step:1,
    showTicks: true,
    getLegend: (value: number): string => {
      switch (value) {
        case 1:
          return 'H6';
          break;
        case 2:
          return 'H5';
          break;
        case 3:
          return 'H4';
          break;
        case 4:
            return 'H3';
            break;
        case 5:
          return 'H2';
          break;
        case 6:
          return 'H1';
          break;
      
        default:
          break;
      }
    
    }
  }
  optionsSet = false;

  headers = [
    {name:"Header 6",value:"h6"},
    {name:"Header 5",value:"h5"},
    {name:"Header 4",value:"h4"},
    {name:"Header 3",value:"h3"},
    {name:"Header 2",value:"h2"},
    {name:"Header 1",value:"h1"},
  ]

  fontSizes = [
    {name:"Tiny",value:"0.625rem",class:"fnt-size-tiny"},
    {name:"Small",value:"0.75rem",class:"fnt-size-small"},
    {name:"Medium Small",value:"0.875rem",class:"fnt-size-medium"},
    {name:"Standard",value:"0.9375rem",class:"fnt-size-standard"},
    {name:"Standard Large",value:"1rem",class:"fnt-size-standard-large"},
    {name:"Standard Larger",value:"1.125rem",class:"fnt-size-standard-larger"},
    {name:"Large",value:"1.375rem",class:"fnt-size-large"},
    {name:"Larger",value:"1.625rem",class:"fnt-size-larger"},
    {name:"Very Large",value:"1.875rem",class:"fnt-size-very-large"},
    {name:"Giant",value:"2rem",class:"fnt-size-gigantic"},
    {name:"Enormous",value:"2.25rem",class:"fnt-size-enormous"}
  ]

  constructor(private cellEditorStoreService:CellEditorStoreService,
    private sectionBuilderStoreService:SectionBuilderStoreService) { }

  ngOnInit(): void {
    console.log(this.content);
    console.log(this.service)
    if(this.content.isHeader){
      this.options.ceil = this.headers.length;
      this.title = "Header";
      if(this.content.classes && this.content.classes.length > 0){
        this.content.classes.forEach(cntClass => {
          let existCheck = this.headers.find(header => header.value == cntClass);
          if(existCheck){
            this.value = this.headers.findIndex(header => header.value == cntClass)+1;
          }else{
            this.value = 1;
          }
        })        
      }
    }else{
      this.options.ceil = this.fontSizes.length;
      this.optionsSet = true;
      if(this.content.fontSizeCls){
        this.value = this.fontSizes.findIndex(fontSize => fontSize.class === this.content.fontSizeCls)+1;
      }
    }
    this.optionsSet = true;
    if(this.status && !this.service){
      switch (this.status) {
        case ContentStatusEnum.CTNT_INITIAL_DRAFT:
          this.service = "sectionBuilder";
          break;
        case ContentStatusEnum.CTNT_FINAL_DRAFT:
          this.service = "cellEditor";
          break;      
        default:
          this.service = "cellEditor"
          break;
      }
    }
    
  }
  onUserChange(changeContext: ChangeContext){
    console.log(changeContext.value);
    //this.marginBottom = changeContext.value;
  }
  onUserChangeStart(changeContext: ChangeContext){
    if(this.service == "sectionBuilder"){
      this.sectionBuilderStoreService.updateEditState(EditState.EDITING)
    }
    console.log({start:changeContext.value})
  }

  onUserChangeEnd(changeContext: ChangeContext){
    console.log({end:changeContext.value});
    console.log(this.fontSizes[changeContext.value  - 1]);
    let choice;
    if(this.content.isHeader){
      choice = this.headers[changeContext.value  - 1];
    }else{
      choice = this.fontSizes[changeContext.value  - 1];
    }
    switch (this.service) {
      case "cellEditor":
      case "cell":
        this.cellEditorStoreService.contentElements$.subscribe((contentElements:ContentElement[]) => {
          console.log(contentElements);
          let contentElement = contentElements.find(element => element.elId == this.content.elId);
          contentElement =  this.cleanupClasses(contentElement);
          contentElement.classes.push(choice.value);
          this.cellEditorStoreService.updateContentElements(contentElements);
          this.cellEditorStoreService.updateSelectorPosChange(choice.value);
        });  
        break;
      case "sectionBuilder":
      case "section":
      case "sectionEditorStoreService":
        this.content =  this.cleanupClasses(this.content);
        this.content.classes.push(choice.value);
        this.sectionBuilderStoreService.updateContent(this.content)  
        //let cntEnumValue = this.getEnumValue(this.content.contentElementEnum)
        this.sectionBuilderStoreService.updateEditState(EditState.UPDATED);  
        break;
      case "sectionStore":
        console.log("SectionStore Service")
        this.content =  this.cleanupClasses(this.content);
        this.content.classes.push(choice.value);

        break
      default:
        /* if(this.content){
          if(this.content.isHeader){
            this.headers.forEach(hdr => {
              if(this.content.classes.includes(hdr.value)){
                let itmIndx = this.content.classes.indexOf(hdr.value);
                if(itmIndx !== -1){
                  console.log("Removing classes")
                  this.content.classes.splice(itmIndx,1);
                }
              }
            })
          }else{
            this.fontSizes.forEach(fontSize => {
              if(this.content.classes.includes(fontSize.class)){
                let itmIndx = this.content.classes.indexOf(fontSize.class);
                if(itmIndx !== -1){
                  console.log("Removing classes")
                  this.content.classes.splice(itmIndx,1);
                }
              }
            })
          }
          this.content.classes.push(choice.value);
          this.sectionBuilderStoreService.updateContent(this.content)
        } */
        break;
    }
   
    
  }

  getEnumValue(cntEnum:ContentElementEnum){
    let enumValue:string;
    if(cntEnum != undefined){
      if((cntEnum).includes(".")){
        let enumKey = cntEnum.split('.')[1] as keyof typeof ContentElementEnum;
        enumValue = ContentElementEnum[enumKey];
      }else if(ContentElementEnum[cntEnum] != undefined){
        enumValue = ContentElementEnum[cntEnum]
      }else{
        enumValue = cntEnum;
      }
    }
    
    return enumValue;
  }
  /**
   * Subroutine to remove existing classes before adding a newly selected class
   * Used for header sizes, font-sizes.
   * Selected class is added back to after cleanup
   * @param cnt 
   */
  cleanupClasses(contentElement:ContentElement):ContentElement{
    if(this.content.isHeader){
      this.headers.forEach(hdr => {
        if(contentElement.classes.includes(hdr.value)){
          let itmIndx = contentElement.classes.indexOf(hdr.value);
          if(itmIndx !== -1){
            console.log("Removing classes")
            contentElement.classes.splice(itmIndx,1);
          }
        }
      })
      //contentElement.classes.push(choice.value);
      //this.cellEditorStoreService.updateSelectorPosChange(choice.value);
     }else{
      this.fontSizes.forEach(fontSize => {
        if(contentElement.classes.includes(fontSize.class)){
          let itmIndx = contentElement.classes.indexOf(fontSize.class);
          if(itmIndx !== -1){
            console.log("Removing classes")
            contentElement.classes.splice(itmIndx,1);
          }
        }
      })
      //contentElement.classes.push(choice.class);
      //this.cellEditorStoreService.updateSelectorPosChange(choice.class);
     }
    return contentElement
  }

  onSubmit(){
    //this.sectionEditorStoreService.updateMarginBottom(this.marginBottom);
  }

}
